import { render, staticRenderFns } from "./PatientUsed.html?vue&type=template&id=1944ba27&"
import script from "./PatientUsed.js?vue&type=script&lang=js&"
export * from "./PatientUsed.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports